import React from 'react'
import PropTypes from 'prop-types'

import EmergencyPhone from '@components/icons/emergency-phone.component'
import ArrowUp from '@components/icons/arrow-up.component'
import ArrowDown from '@components/icons/arrow-down.component'
import Messages from '@components/icons/messages.component'
import Tips from '@components/icons/tips.component'
import Settings from '@components/icons/settings.component'
import Pin from '@components/icons/pin.component'
import PinSmall from '@components/icons/pin-small.component'
import Mask from '@components/icons/mask.component'
import Send from '@components/icons/send.component'
import Emergency from '@components/icons/emergency.component'
import Alert from '@components/icons/alert.component'
import Check from '@components/icons/check.component'
import Error from '@components/icons/error.component'
import Search from '@components/icons/search.component'
import Close from '@components/icons/close.component'
import Image from '@components/icons/resource-image.component'
import Link from '@components/icons/resource-link.component'
import Pdf from '@components/icons/resource-pdf.component'
import Phone from '@components/icons/resource-phone.component'
import Video from '@components/icons/resource-video.component'
import Document from '@components/icons/document.component'
import LogoPowered from '@components/icons/logo-powered.component'

const Icon = ({ type, style }) => {
  switch (type) {
  case 'emergency-phone':
    return <EmergencyPhone style={style} />
  case 'arrow-up':
    return <ArrowUp />
  case 'arrow-down':
    return <ArrowDown />
  case 'messages':
    return <Messages />
  case 'tips':
    return <Tips />
  case 'resources':
  case 'document':
    return <Document />
  case 'settings':
    return <Settings />
  case 'pin':
    return <Pin />
  case 'pin-small':
    return <PinSmall />
  case 'mask':
    return <Mask />
  case 'send':
    return <Send />
  case 'check':
    return <Check />
  case 'emergency':
    return <Emergency />
  case 'error':
    return <Error />
  case 'search':
    return <Search />
  case 'close':
    return <Close />
  case 'video':
    return <Video />
  case 'phone':
    return <Phone />
  case 'image':
    return <Image />
  case 'pdf':
    return <Pdf />
  case 'link':
    return <Link />
  case 'alert':
    return <Alert />
  case 'logo-powered':
    return <LogoPowered />
  default:
    return null
  }
}

Icon.defaultProps = {
  type: ''
}

Icon.propTypes = {
  type: PropTypes.string
}

export default Icon
